/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FaqFeedback from '../common/FaqFeedback';
import FaqTicketCreate from '../common/FaqTicketCreate';
import styles from '../../styles/Accordion.module.scss';
import { clickTracker, getProjectId, getSourceValue, handleRedirection, helpfulObjData } from '../../lib/common';
import { handleShowTagsFeedback } from '../../reducersAndActions/actions/appStateActions';
import { useAppState } from '../../contexts/appState';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

const EditBusinessFaq = ({ faqsData, setShowEditLisingPage, setShowEditLisingPageResp }) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const [faqResponse, setFaqResponse] = useState(faqsData || []);
  const [showData, setShowData] = useState(false);
  const [selectedFaqData, setSelectedFaqData] = useState({});
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [helpful, setHelpful] = useState(helpfulObjData && helpfulObjData);
  const [faqsFeedbackData, setFaqsFeedbackData] = useState({});
  const projectId = getProjectId();
  const source = getSourceValue();
  const [, appDispatch] = useAppState();
  const [authState] = useAuth();

  const handleFaqClick = async (data, index) => {
    handleShowTagsFeedback(appDispatch, {});
    setActiveIndex(index === activeIndex ? -1 : index);
    setShowData(true);
    setHelpful(helpfulObjData && helpfulObjData);
    setSelectedFaqData(data);
    setShowEditLisingPage(true);
    setShowEditLisingPageResp('');
    setSelectedQuestionId(selectedQuestionId === data?.pop ? null : data?.pop);
    if (data.type === 'button') {
      handleRedirection(source, data?.paramUrl || '');
    }
    if (selectedQuestionId !== data?.pop) {
      await clickTracker(`FAQ_${data?.faqKey}`, 'editdata_FAQ');
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `faq_${data?.faqKey}`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = 'issue_editbusiness';
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }
  };

  const handleCategoriesClick = async (e) => {
    if (selectedFaqData?.pop === 1 && selectedFaqData?.paramUrl && e.target.id === 'categories') {
      await clickTracker(`FAQ_updtkeywords_click`, 'editdata_FAQ_updtkeywords');
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `cta_clickhere`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = `issue_editBusiness`;
        const llTrdInside = `faq_${selectedFaqData?.faqKey}`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
      }
      handleRedirection(source, selectedFaqData?.paramUrl || '');
    }
  };

  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');
  useEffect(() => {
    const handleFaqData = () => {
      const data = faqResponse;
      if (searchQid && searchQid !== '') {
        data?.forEach((ele, i) => {
          if (ele?.id?.toString() === searchQid) {
            data?.splice(i, 1);
            data?.unshift(ele);
          }
        });

        data?.forEach((faq, i) => {
          if (faq?.id?.toString() === searchQid) {
            handleFaqClick(faq, i);
          }
        });
      }
      setShowData(true);
      setFaqResponse([...data]);
    };
    handleFaqData();
  }, []);

  return (
    <div className={`${styles.Accordion__Box}`}>
      <div className="mt-10">
        {faqResponse && faqResponse.length > 0 ? (
          <>
            {faqResponse &&
              faqResponse.map((each, idx) => (
                <div key={idx}>
                  <div
                    onClick={() => handleFaqClick(each, idx)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={() => {}}
                    className={`${styles.Accordion__Pannel__Heading} ${
                      activeIndex === idx && each?.type !== 'button' ? styles.Active : ''
                    }`}
                  >
                    <div className={`${styles.Accordion__Pannel__Title} font13 fw500 color111`}>
                      {each?.question || ''}
                    </div>
                    <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                  </div>
                  {each?.type !== 'button' && (
                    <div className={`${styles.Accordion__Contant}`}>
                      <div className={`${styles.Accordion__TextContant}`}>
                        {showData && each?.type !== 'create' ? (
                          <>
                            <div
                              onClick={handleCategoriesClick}
                              aria-hidden="true"
                              className="font12 fw400 color777 p-10"
                              id="payments-faqs-ans"
                              dangerouslySetInnerHTML={{ __html: each?.ans }}
                            />
                            {each?.faqKey === 'updtkeywords' && (
                              <FaqFeedback
                                faq={each}
                                helpful={helpful}
                                setHelpful={setHelpful}
                                setShowData={setShowData}
                                faqsFeedbackData={faqsFeedbackData}
                                setFaqsFeedbackData={setFaqsFeedbackData}
                                id="editBusiness"
                                projectId={projectId}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            {((helpful && helpful[1].isActive) || each?.type === 'create') && (
                              <div className={each?.type === 'create' || projectId === 'genio' ? 'p-10' : ''}>
                                <FaqTicketCreate
                                  issue={each?.issue || ''}
                                  subIssue={each?.subIssue || ''}
                                  activeIndex={activeIndex}
                                  vertical="Listing"
                                  category="CS"
                                  ticketCreator="BUSINESS"
                                  setShowData={setShowData}
                                  hideAlert
                                  hideCrossIcon={each?.type === 'create'}
                                  id="editBusiness"
                                  faqId={each?.pop}
                                  projectId={projectId}
                                  trackerKey={selectedFaqData?.faqKey}
                                  faqObj={each}
                                />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </>
        ) : (
          <div className="no-data-div">No Data</div>
        )}
      </div>
    </div>
  );
};

EditBusinessFaq.propTypes = {
  faqsData: PropTypes.array,
  setShowEditLisingPage: PropTypes.func,
  setShowEditLisingPageResp: PropTypes.func,
};

export default EditBusinessFaq;
